import React, { useEffect, useRef, useState } from "react";
import StaticTypeWriterWithParser from "./StatictTypeWritingEffect/StaticTypeWriterWithParser";
import StaticTypeWriter from "./StatictTypeWritingEffect/StaticTypeWriter";
import StaticFooter from "./StaticFooter";
import { staticHeader } from "../../Services/CommonServices/helper";

const SpecialDelivery = () => {
  const [isTitle, setIsTitle] = useState(false);
  const [isContent, setIsContent] = useState(false);
  const [isContentTwo, setIsContentTwo] = useState(false);
  const [isFooter, setIsFooter] = useState(false);
  const [downArrow, setShowDownArrow] = useState(false);
  const effects = false;
  const titleHeader = "Special Delivery";
  // NOTE: This text appears twice: once via staticHeader(titleHeader) and once as a hidden StaticTypeWriter text.
  // Keep it identical to avoid mismatches and prevent duplicate rendering.
  const subheader = "To celebrate America's 250th, the U.S. Postal Service invited Ralph Lauren to create a collection of commemorative stamps.";
  const effectRan = useRef(false);

  useEffect(() => {
    if (!effectRan.current) {
      staticHeader(titleHeader, 'titleHeader')
    }
    staticHeader(subheader, 'subHeaderContainer')
    return () => effectRan.current = true;
  }, [isTitle]);

  // scroll to bottom arrow functionality
  useEffect(() => {
    const pageContainer = document.getElementById('styleGuidePageContainer');
    if (!pageContainer) return;

    let initialViewportHeight = pageContainer.clientHeight;
    const handleScroll = () => {
      const overflownspace = pageContainer.scrollHeight - pageContainer.scrollTop - pageContainer.clientHeight;
      if (overflownspace > initialViewportHeight * 0.1) {
        setShowDownArrow(true);
      } else {
        setShowDownArrow(false);
      }
      return;
    };

    const observer = new MutationObserver(() => {
      setTimeout(handleScroll, 100);
    });
    observer.observe(pageContainer, { childList: true, subtree: true });
    pageContainer.addEventListener('scroll', handleScroll);
    handleScroll();
    setTimeout(handleScroll, 300);
    return () => {
      pageContainer.removeEventListener('scroll', handleScroll);
      setShowDownArrow(false);
      observer.disconnect();
    }
  }, []);

  const scrollToEnd = () => {
    const pageContainer = document.getElementById('styleGuidePageContainer');
    if (pageContainer) {
      pageContainer.scrollTo({
        top: pageContainer.scrollHeight - 100,
        behavior: 'smooth'
      });
      setShowDownArrow(false);
    }
  };

  const adjustDownArrowPosition = () => {
    const downArrowElement = document.querySelector('.down-arrow');

    if (downArrowElement) {
      downArrowElement.style.bottom = '15px';
      downArrowElement.style.left = '50%';
      downArrowElement.style.transform = 'translateX(-50%)';
    }
  };

  useEffect(() => {
    adjustDownArrowPosition();

    const handleResize = () => {
      adjustDownArrowPosition();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [downArrow]);

  return (
    <div>
      <div
        className="container p-0 art-of-bundling-up overflow"
        style={{ backgroundColor: "#EFEFEF" }}
        id="styleGuidePageContainer"
      >
        <div>
          <img
            src="/static/assets/StaticLandingPageImages/SpecialDelivery-topimg.png"
            alt="top-img" width="100%"
            className="top-img"
          />
        </div>
        <div className="content card align-items-center mb-0">
          <div>
            <div className="title" id="titleHeader">
              <div style={{ display: "none" }}>
                <StaticTypeWriter
                  text={"Special Delivery"}
                  setLoading={setIsTitle}
                />
              </div>
            </div>
            {isTitle &&
              <div className="subheader" id="subHeaderContainer">
                <div style={{ display: "none" }}>
                  <StaticTypeWriter
                    text={"To celebrate America's 250th, the U.S. Postal Service invited Ralph Lauren to create a collection of commemorative stamps."}
                    setLoading={() => {}}
                  />
                </div>
              </div>
            }
            <div className="carousel-polar-div">
              <div className="carousel-polar-div">
                <div>
                  <div>
                    <div>
                      <div className="description carousel-polar-div">


                        <StaticTypeWriterWithParser
                          text={`<p>
                            A trusted pickup truck, worn and weathered on a country road. The Empire State Building, shining bright on an autumn night in New York, a majestic beacon of the power of dreams. Horses, running free across the open plains out west. Across nearly 60 years as a designer, Ralph Lauren has been deeply inspired by America’s visual poetry—its vibrant heritage, rich landscapes, and singular artistry. In fact, it is America—the place where anyone and everyone can share the dream—that has influenced him and his enduring creative vision above all else.
                          </p>`}
                          effects={effects}
                          setLoading={setIsContent}
                        />
                        <div style={{ marginBottom: "30px" }}>
                            <img
                            src="/static/assets/StaticLandingPageImages/SpecialDelivery-img1.png"
                            alt="img"
                            width="100%"
                          />
                        </div>
                          <StaticTypeWriterWithParser
                          text={`<p>
                            Now, as the country comes together to celebrate its 250th birthday, the U.S. Postal Service has invited Ralph to curate a special issuance of commemorative stamps. The result is “American Icons,” 13 stamps that celebrate the essence of our country. Selected in part from Ralph’s unparalleled visual archive, and from visuals that have inspired him, the images embody America’s shared values—freedom, independence, equality, opportunity, and the pursuit of happiness—while also reflecting the rich, unique fabric of our nation.
                          </p>`}
                          effects={effects}
                          setLoading={setIsContent}
                        />
                        <div style={{ marginBottom: "30px" }}>
                            <img
                            src="/static/assets/StaticLandingPageImages/SpecialDelivery-img2.jpg"
                            alt="img"
                            width="100%"
                          />
                        </div>
                        <div style={{ marginBottom: "30px" }}>
                            <img
                            src="/static/assets/StaticLandingPageImages/SpecialDelivery-img3.jpg"
                            alt="img"
                            width="100%"
                          />
                        </div>
                        <StaticTypeWriterWithParser
                          text={`<p>
                            “I love America,” Ralph says, “and these images symbolize the many ideals and aspirations that bind us together. They are the icons of our country—authentic, timeless, and passed down through generations—and reflect the dream of a better life that has always inspired me.”
                          </p>`}
                          effects={effects}
                          setLoading={setIsContent}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isContent && (
          <div className="carousel-polar-div">
            <div className="carousel-polar-div">
              <div>
                <div>
                  <div>
                    <img
                      src="/static/assets/StaticLandingPageImages/SpecialDelivery-backimg.jpg"
                      alt="img"
                      className="polo_img"
                    />
                      <div className="content-static card align-items-center" style={{paddingTop: '15px'}}>
                      <div className="description carousel-polar-div">
                        <div className="content-static card align-items-center mb-0">
                          <div className="title" style={{color: "#041e3a"}}>Renewed Glory</div>
                        </div>
                        <div className="subheader" style={{color: "#041e3a"}}>
                          <div>
                            How Ralph Lauren helped conserve the Star-Spangled Banner
                          </div>
                        </div>
                        <StaticTypeWriterWithParser
                          text={`<p>
                            For Francis Scott Key, it was the majestic sight of an American flag waving over Fort McHenry at dawn in 1813 that inspired him to write “The Star-Spangled Banner.” For 25 hours, British ships had bombed the American fort. By morning the flag, as Key wrote, still waved … “o’er the land of the free and the home of the brave.”
                          </p>`}
                          effects={effects}
                          setLoading={() => {}}
                        />
                        <StaticTypeWriterWithParser
                          text={`<p>
                            That flag, forever known as the Star-Spangled Banner, is now among the most-revered American treasures, with millions coming to the Smithsonian Institution in Washington, D.C. each year to pay homage. The flag famously endured bombardment, but by 1998 it was falling apart from age, showing signs of wear and tear and in need of preservation. That’s when Ralph Lauren stepped in.
                          </p>`}
                          effects={effects}
                          setLoading={() => {}}
                        />
                        <StaticTypeWriterWithParser
                          text={`<p>
                            The collaboration with Steiff ended in 2001, and production of the special-edition sweaters was pulled back around the same time. But during the past few years, the Polo Bear has returned, popping up everywhere from the US Open, where you could have the bear, wearing the official ballboy uniform, customized with your name and printed onto a Polo shirt, to a version on John Mayer. In 2017, he even made his Purple Label debut, appearing on the Italian-made Western Bear sweatshirt, followed by an appearance on a grey sweater, himself wearing a cricket sweater and toggle coat. (A 2017 camel coat offered further homage—it was crafted using the same fabric Steiff used for the original bears.)
                          </p>`}
                          effects={effects}
                          setLoading={() => {}}
                        />
                        <StaticTypeWriterWithParser
                          text={`<p>
                            The story continued into 2019, as the Collegiate Bear made his debut on a Polo sweater. He beat out three other bears—none of whom had ever appeared on a sweater—in the first-ever Polo Bear vote on the former Polo App (now part of The Ralph Lauren App, which you can download now from the App Store or Google Play). Soon afterward came the Polo Bear watch collection, created in celebration of Ralph Lauren’s 50th anniversary. The limited-run, Swiss-made collection consisted of four models, each emblazoned with a different Polo Bear, and each embodying a different take on Polo style: Preppy Bear, Martini Bear, Flag Bear, and Spectator Bear. And, as a nod to Ralph Lauren’s original design—the necktie—each watch comes with an extra strap made with necktie silk, alongside a strap of French calfskin or exotic alligator.
                          </p>`}
                          effects={effects}
                          setLoading={() => {}}
                        />
                      </div>
                      <div style={{ marginBottom: "30px" }}>
                        <img
                          src="/static/assets/StaticLandingPageImages/SpecialDelivery-img4.jpg"
                          alt="img"
                          width="100%"
                        />
                      </div>
                      <div className="description carousel-polar-div">
                        <StaticTypeWriterWithParser
                          text={`<p>
                            In his life and work, Ralph has been moved by the ways iconic symbols express our ideals and aspirations as Americans, with the flag representing both our past and our future as no other image can. Ralph took the lead in the fundraising needed to help save the Star-Spangled Banner. After careful preservation, the flag was moved to a custom-built environmentally controlled chamber at the Smithsonian, where the 34-by-30-foot Star-Spangled Banner is now the focus of a permanent exhibition that educates visitors about the battle that inspired our national anthem, details a century of efforts to preserve the flag itself, and explores flag symbolism in American history.
                          </p>`}
                          effects={effects}
                          setLoading={setIsContentTwo}
                        />
                        <StaticTypeWriterWithParser
                          text={`<p>
                            "I am the product of the American dream,” Ralph says, “and the flag is its symbol. Its preservation and conservation is imperative so that those who succeed us will understand our nation’s heritage and the ideals on which the United States was founded. The Star-Spangled Banner was an inspiration to Francis Scott Key. It’s been an inspiration for me.”
                          </p>`}
                          effects={effects}
                          setLoading={setIsContentTwo}
                        />
                      </div>
                      {isContentTwo && (
                          <StaticTypeWriter
                            setLoading={setIsFooter}
                          />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isFooter && <StaticFooter />}

        {downArrow && (
          <button
            className="down-arrow"
            onClick={scrollToEnd}
            style={{
              position: 'fixed',
              bottom: '44px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 1001,
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img
              alt="down-arrow"
              src="./static/assets/scrollDown.svg"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default SpecialDelivery;
